export default __webpack_public_path__ + "b3f0fcac89fb9c893808c7ac2505a35d.png";